export default __webpack_public_path__ + "static/media/firebase.ea1a2d66.svg";